import _regeneratorRuntime from "babel-runtime/regenerator";
import _typeof from "babel-runtime/helpers/typeof";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";
/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/**
 * Quick Shop methods
 * -----------------------------------------------------------------------------
 *
 * @namespace quickShop
 */

import axios from 'axios';
import detectIt from 'detect-it';
import Flickity from 'flickity';
import 'flickity-bg-lazyload';

var quickShopMethods = {
  data: function data() {
    return {
      quickShop: {
        isQuickshopModalOpen: false,
        currentVariant: {},
        product: {},
        images: {},
        variants: {},
        inventory: null,
        badgeTags: null,
        optionImages: {},
        metafields: null,
        discountPercentage: '',
        prod_refurbish_meta: "",
        prod_damaged_meta: "",
        refurbished_prod: {},
        damaged_prod: {},
        main_prod: {},
        refur_prod: {},
        damag_prod: {}
      }
    };
  },


  methods: {
    /**
     * Adds a variant from wishlist Array
     * @param  {productHandle}
     *
     */
    _viewQuickShop: function _viewQuickShop(productHandle, selectedOptions, event, selectedVariant) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var $modal, $modalBody, $qtyEl, $carousel1, $carousel2, carouselOptions1, carouselOptions2, flktyMain, flktyNav, cellElements1, cellElements2, productId;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                $modal = $('[data-template="quickshop"]');
                $modalBody = $modal.find('.modal-body');
                $qtyEl = $modal.find(app.selectors.qtyInput);
                $carousel1 = void 0;
                $carousel2 = void 0;
                carouselOptions1 = void 0;
                carouselOptions2 = void 0;
                flktyMain = void 0;
                flktyNav = void 0;
                cellElements1 = void 0;
                cellElements2 = void 0;
                productId = void 0;

                app.isLoading = true;

                // get product main data
                _context.next = 15;
                return axios.get("/products/" + productHandle + ".js").then(function (response) {
                  app.quickShop.product = response.data;
                  productId = response.data.id;
                  return response;
                }).catch(function (error) {
                  console.log(error);
                  throw error;
                });

              case 15:
                _context.next = 17;
                return axios.get("/products/" + productHandle + "?view=json").then(function (response) {
                  function jsonEscape(str) {
                    return str.replace(/\\n/g, " ").replace(/\r/g, " ").replace(/\t/g, " ").replace(/'/g, "’").replace(/&#39;/g, "’").replace(/&quot;/g, "”");
                  }
                  var json_escape = jsonEscape(JSON.stringify(response.data));
                  var res = JSON.parse(json_escape);
                  var response_data = void 0;
                  if ((typeof res === "undefined" ? "undefined" : _typeof(res)) !== 'object') {
                    response_data = JSON.parse(res);
                  } else {
                    response_data = res;
                  }
                  app.isLoading = false;
                  app.quickShop.inventory = response_data.inventory;
                  app.quickShop.images = response_data.images;
                  var variantName = '';
                  var variantImages = [];
                  response_data.product.variants.forEach(function (variant) {
                    // eslint-disable-next-line eqeqeq
                    if (variant.id == selectedVariant) {
                      variantName = variant.title;
                      app.quickShop.currentVariant = variant;
                    }
                  });
                  response_data.product.media.forEach(function (image) {
                    // eslint-disable-next-line eqeqeq
                    if (image.alt == variantName) {
                      variantImages.push(image);
                    }
                  });

                  if (variantImages.length > 0) {
                    app.quickShop.images = variantImages;
                  } else {
                    app.quickShop.images = response_data.images;
                  }
                  app.quickShop.optionImages = response_data.option_images;
                  app.quickShop.variants = response_data.variants;
                  // eslint-disable-next-line eqeqeq
                  if ($.trim(response_data.short_description) != '') {
                    app.quickShop.metafields = response_data.short_description;
                  }
                  if ($.trim(response.data.prod_refurbish_meta) != '') {
                    app.quickShop.prod_refurbish_meta = response.data.prod_refurbish_meta;
                  }
                  if ($.trim(response.data.prod_damage_meta) != '') {
                    app.quickShop.prod_damaged_meta = response.data.prod_damage_meta;
                  }
                  // assign the product cart limit
                  app.quickShop.product.cart_limit = null;
                  app.quickShop.product_handle_tag_refurbish = null;
                  app.quickShop.product_handle_tag_damagebox = null;
                  app.quickShop.product_hand_refur = null;
                  app.quickShop.product_hand_damag = null;

                  app.quickShop.main_prod_handle = '';
                  var tagsArray = '';
                  if (app.quickShop.product.tags) {
                    app.quickShop.product.tags.forEach(function (tag) {
                      if (tag.match('cart-limit')) {
                        var cartLimit = tag.replace('cart-limit-', '');
                        app.quickShop.product.cart_limit = parseFloat(cartLimit);
                      }
                      if (tag.indexOf('badge_') > -1) {
                        var tagMain = tag.replace('badge_', '');
                        var bgBadge = tagMain.split('_')[1];
                        var textBadge = tagMain.split('_')[0];
                        tagsArray += '<span style="background-color:' + bgBadge + '" class="badge ml-2 badge-left badge-warning text-uppercase text-white letter-spacing-1">' + textBadge + '</span>';
                      }
                      if (tag.match('product_warranty_')) {
                        var warranty_product = 'yes';
                        app.quickShop.product.warranty_product = warranty_product;
                      }
                      if (tag.match('kit_')) {
                        var _tagMain = tag.replace('kit_', '');
                        var kit_val = _tagMain.split('_')[0];
                        if (kit_val && kit_val != '') {
                          var product_kit_type = 'yes';
                          app.quickShop.product.product_kit_type = product_kit_type;
                          app.quickShop.product.kit_count = kit_val;
                        }
                      }

                      if (tag.match('preventa_')) {
                        var dateCheck = tag.split('preventa_');
                        var today = new Date();
                        var preorderDate = new Date(dateCheck[1]);
                        if (preorderDate > today) {
                          app.quickShop.product.itsPreorder = tag;
                        }
                      }
                      if (tag.match('seller_')) {
                        var marketplaceSaller = tag.split('seller_');
                        app.quickShop.product.marketplaceSaller = marketplaceSaller[1];
                      }
                      if (tag.match('enverde-')) {
                        app.quickShop.product.dropShipping = tag;
                      }

                      if (tag.match('product_refurbish_')) {
                        app.quickShop.product_handle_tag_refurbish = tag.split('product_refurbish_')[1];
                        axios.get("/products/" + app.quickShop.product_handle_tag_refurbish + "?view=json").then(function (response) {
                          app.quickShop.refurbished_prod = response.data.product;
                        });
                      }
                      if (tag.match('product_damagebox_')) {
                        app.quickShop.product_handle_tag_damagebox = tag.split('product_damagebox_')[1];
                        axios.get("/products/" + app.quickShop.product_handle_tag_damagebox + "?view=json").then(function (response) {
                          app.quickShop.damaged_prod = response.data.product;
                        });
                      }

                      if (tag.match('main_product_')) {
                        app.quickShop.main_prod_handle = tag.split('main_product_')[1];
                        axios.get("/products/" + app.quickShop.main_prod_handle + "?view=json").then(function (response) {
                          app.quickShop.main_prod = response.data.product;
                          app.quickShop.main_prod.tags.forEach(function (t) {
                            if (t.match('product_refurbish_')) {
                              app.quickShop.product_hand_refur = t.split('product_refurbish_')[1];
                              axios.get("/products/" + app.quickShop.product_hand_refur + "?view=json").then(function (response) {
                                app.quickShop.refur_prod = response.data.product;
                              });
                            }
                            if (t.match('product_damagebox_')) {
                              app.quickShop.product_hand_damag = t.split('product_damagebox_')[1];
                              axios.get("/products/" + app.quickShop.product_hand_damag + "?view=json").then(function (response) {
                                app.quickShop.damag_prod = response.data.product;
                              });
                            }
                          });
                        });
                      }
                    });
                  }
                  app.quickShop.badgeTags = tagsArray;

                  var array = [];
                  var tempObj = {};
                  var tempArray = [];
                  app.quickShop.product.properties = { 'tags': app.quickShop.product.tags.toString(), 'sku': app.quickShop.currentVariant.sku, 'inventory': app.quickShop.inventory, 'weight': app.quickShop.currentVariant.weight / 1000 };
                  app.quickShop.product.variant_id = app.quickShop.currentVariant.id;
                  app.quickShop.product.product_type = app.quickShop.product.type;
                  app.quickShop.product.quantity = 1;
                  array.push(app.quickShop.product);

                  array.forEach(function (item, index) {
                    for (var subitem in item) {
                      if (subitem == 'id' || subitem == 'properties' || subitem == 'variant_id') {
                        tempObj[subitem] = item[subitem];
                      }
                    }
                  });
                  tempArray.push(tempObj);

                  if (app._getCookie('selCommonC') == app._getCookie('selectedComuna')) {
                    var contains = { items: tempArray };
                    if (app.quickShop.product.itsPreorder != null) {
                      var shipping_type = 'preorder';
                    } else if (app.quickShop.product.marketplaceSaller != null) {
                      var shipping_type = 'marketplace';
                    } else {
                      var shipping_type = 'delivery';
                    }

                    if (app.cart.attributes != undefined) {
                      if (app.cart.attributes["Region"] && app.cart.attributes["Region"] != '') {
                        var valReg = app.cart.attributes["Region"];
                      } else {
                        if (app._getCookie('selCommonR') != undefined && app._getCookie('selCommonR') != '' && app._getCookie('selCommonR') != 'selCommonR') {
                          var valReg = app._getCookie('selCommonR');
                        } else {
                          var valReg = '';
                        }
                      }
                    } else {
                      if (app._getCookie('selCommonR') != undefined && app._getCookie('selCommonR') != '' && app._getCookie('selCommonR') != 'selCommonR') {
                        var valReg = app._getCookie('selCommonR');
                      } else {
                        var valReg = '';
                      }
                    }

                    if (app.cart.attributes != undefined) {
                      if (app.cart.attributes["Comuna"] && app.cart.attributes["Comuna"] != '') {
                        var valCom = app.cart.attributes["Comuna"];
                      } else {
                        if (app._getCookie('selCommonC') != undefined && app._getCookie('selCommonC') != '' && app._getCookie('selCommonC') != 'selCommonC') {
                          var valCom = app._getCookie('selCommonC');
                        } else {
                          var valCom = '';
                        }
                      }
                    } else {
                      if (app._getCookie('selCommonC') != undefined && app._getCookie('selCommonC') != '' && app._getCookie('selCommonC') != 'selCommonC') {
                        var valCom = app._getCookie('selCommonC');
                      } else {
                        var valCom = '';
                      }
                    }

                    if (valReg && valReg != '' && valReg != null && valReg != undefined && valCom && valCom != '' && valCom != null && valCom != undefined) {
                      var data = {
                        location_id: 'null',
                        shipping_type: shipping_type,
                        region: app._getCookie('selCommonR'),
                        district: app._getCookie('selCommonC'),
                        cart: JSON.stringify(contains),
                        date_count: 10,
                        change_shipping_type: 0
                      };

                      if (app.freeShippingEnabled) {
                        var ajax_url = 'https://app.kitchencenter.cl/api/calendar/shipping-new-free';
                      } else {
                        var ajax_url = 'https://app.kitchencenter.cl/api/calendar/shipping-new';
                      }
                      $.ajax({
                        type: 'POST',
                        url: ajax_url,
                        dataType: 'json',
                        data: data,
                        success: function success(data) {
                          var item = data[0];
                          if (item.type == 'preorder') {
                            $('input.shipp_date_prop').val(item.start_date);
                            $('input.shipp_rangedate_prop').val(item.start_date + ' - ' + item.end_date);
                            $('input.shipp_fulldate_prop').val(item.fulfillment_date);
                          } else if (item.type == 'marketplace') {
                            $('input.shipp_date_prop').val(item.delivery_date);
                            $('input.shipp_rangedate_prop').val(item.start_date + ' - ' + item.end_date);
                            $('input.shipp_fulldate_prop').val(item.fulfillment_date);
                          } else {
                            var ship_pick_dates = item.shipping_dates;
                            var firstDate = '';
                            var firstFullfillDate = '';
                            var count = 0;
                            $.each(ship_pick_dates, function (shipping_date) {
                              if (count == 0) {
                                firstDate = shipping_date;
                                firstFullfillDate = ship_pick_dates[shipping_date].fulfilment_date;
                              }
                              count = count + 1;
                            });
                            $('input.pick_available').val(item.pick_available);
                            $('input.delivery_available').val('');
                            $('input.shipp_date_prop').val(firstDate);
                            $('input.shipp_fulldate_prop').val(firstFullfillDate);
                          }

                          if ($('input.shipp_price_prop').val() == '') {
                            $('input.shipp_price_prop').val(item.shipping_price);
                          }
                          if (item.same_day_delivery_option == true) {
                            $('input.same_day_del').val(item.same_day_delivery_option);
                          }

                          if (item.allow_24H_delivery == true && app._getCookie('selCommonC') == app._getCookie('selectedComuna')) {
                            app.quickShop.product.chck2del24h = 'yes';
                          } else {
                            app.quickShop.product.chck2del24h = 'no';
                          }
                        }
                      });
                    }
                  }

                  $modal.on('shown.bs.modal', function (e) {
                    app.isQuickshopModalOpen = true;
                    $carousel1 = $(this).find('[data-carousel-main]');
                    $carousel2 = $(this).find('[data-carousel-nav]');

                    // re-init tooltips but only for desktop
                    if (!detectIt.hasTouch) {
                      $('[data-toggle="tooltip"]').tooltip();
                    }

                    if ($carousel1.length > 0) {
                      carouselOptions1 = $carousel1.data('flickity-options');
                      flktyMain = new Flickity($carousel1[0], carouselOptions1);
                      cellElements1 = flktyMain.getCellElements();
                      flktyMain.resize();
                      setTimeout(function () {
                        flktyMain.selectCell(0, true, false);
                      }, 500);
                    }

                    if ($carousel2.length > 0) {
                      carouselOptions2 = $carousel2.data('flickity-options');
                      flktyNav = new Flickity($carousel2[0], carouselOptions2);
                      cellElements2 = flktyNav.getCellElements();
                      flktyNav.resize();
                      setTimeout(function () {
                        flktyNav.selectCell(0, true, false);
                      }, 500);
                    }

                    if (selectedOptions == '') {
                      selectedOptions = app.quickShop.product.variants[0].options;
                    }

                    selectedOptions.forEach(function (option) {
                      $("[data-template=\"quickshop\"] input[value=\"" + option + "\"]").trigger('click');
                      $("[data-template=\"quickshop\"] option[value=\"" + option + "\"]").prop('selected', true);
                    });

                    setTimeout(function () {
                      // app._getVariant(event);
                      // app._getRestockData(app.quickShop.product.id, app.quickShop.variants, app.quickShop.product.tags);
                    }, 100);

                    setTimeout(function () {
                      // open modal
                      $modalBody.addClass('opened');
                    }, 400);
                  });

                  $modal.on('hidden.bs.modal', function (e) {
                    // resets
                    $qtyEl.val(1); // reset qty input to 1
                    app.quickShop.product = {};
                    app.quickShop.images = {};
                    app.quickShop.currentVariant = {};
                    app.isQuickshopModalOpen = false;
                    $modalBody.removeClass('opened');

                    app.backInStockerror = false;
                    app.backInStockDone = false;

                    // destroy carousel if exists
                    if ($carousel1.length > 0) {
                      flktyMain.destroy();
                    }
                    // destroy carousel if exists
                    if ($carousel2.length > 0) {
                      flktyNav.destroy();
                    }

                    $('input.shipp_date_prop').val('');
                    $('input.pick_available').val('');
                    $('input.delivery_available').val('');
                    $('input.shipp_price_prop').val('');
                  });

                  $modal.modal('show');
                  return response;
                }).catch(function (error) {
                  // console.log(error);
                  throw error;
                });

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
};

export default quickShopMethods;